import React, { useEffect, useRef, useState } from 'react';
import { get, post } from '../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../util/constant';
import { Button, Col, FloatingLabel, Form, Modal, Row, Table } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { ViewIcon } from './icons';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from './Pagination';
import { MdDelete } from 'react-icons/md';
import { GrDocumentPdf, GrDocumentExcel } from 'react-icons/gr';
import { getStoredData, get_auth_key } from '../util';
import useDebounce from './useDebounce';
import Breadcrumb from '../components/Breadcrumb';
import Company from '../components/company';

const Transfer = () => {
  const formFields = { transferDate: new Date().toJSON().slice(0, 10), fromLocationId: '', toLocationId: '', assetsInfo: [] };
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [transferForm, setTransferForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [transferList, setTransferList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [assetList, setAssetList] = useState({});
  const [assetCategoryList, setAssetCategoryList] = useState([]);
  const [inputFields, setInputFields] = useState([]);
  const [srcLocationType, setSrcLocationType] = useState('');
  const [dstLocationType, setDstLocationType] = useState('');

  const clickAssetBtn = useRef(null);
  const clickToDownload = useRef(null);
  const storedData = JSON.parse(getStoredData(get_auth_key()));

  const admins = ['admin', 'super-admin', 'fixed-asset-admin'].includes(storedData.role);

  const [state, setState] = useState({
    assetCategoryQuery: '',
    sourceLocationId: '',
    destinationLocationId: '',
    dateFrom: '',
    dateTo: '',
    companyId: !admins ? storedData?.companyId || '' : '',
  });

  const handleShow = () => {
    setShowConfirmModel(true);
    setTransferForm({
      ...formFields,
      fromLocationId: '',
      fromLocationType: '',
      fromLocationAddress: '',
      fromCompanyId: '',
    });
    setTimeout(() => {
      clickAssetBtn.current?.click();
    }, 100);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
    setInputFields([]);
    setTransferForm(formFields);
  };
  const handleViewAndEdit = async (e, id, conditionType) => {
    e.preventDefault();
    {
      conditionType !== 'download' ? setShowConfirmModel(true) : setShowConfirmModel(false);
    }
    try {
      get(`/transfers/?id=${id}&conditionType=${conditionType}`).then((response) => {
        if (conditionType !== 'download') {
          let _transferForm = response.data.rows[0];
          let fromLocationData = loadLocationData(_transferForm?.fromLocationId);
          let toLocationData = loadLocationData(_transferForm?.toLocationId);
          setTransferForm({
            ..._transferForm,
            fromLocationAddress: fromLocationData?.address,
            fromLocationType: fromLocationData?.type,
            fromCompanyId: fromLocationData?.companyId,
            toLocationAddress: toLocationData?.address,
            toLocationType: toLocationData?.type,
            toCompanyId: toLocationData?.companyId,
          });
          let _inputFields = _transferForm.TransfersDetails;
          let _assetList = {};
          (async () => {
            for (let x = 0; x < _inputFields.length; x++) {
              const da = await get(
                `/assets/?locationId=${_transferForm.fromLocationId}&assetCategoryId=${_inputFields[x].assetCategoryId}`
              );
              _assetList = { ..._assetList, [x]: da.data.rows };
              // Find and set the vehicle number from the fetched assets
              const matchingAsset = da.data.rows.find(asset => asset.id === parseInt(_inputFields[x].asset_id));
              if (matchingAsset) {
                _inputFields[x]['vehicleNumber'] = matchingAsset.vehicleNumber;
              }
            }
            setAssetList(_assetList);
          })();
          setInputFields(_inputFields);
          setShowConfirmModel(true);
        } else {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        }
      });
    } catch (error) {
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const loadLocationData = (locationId) => {
    return locationList.find((item) => {
      return item?.id === parseInt(locationId);
    });
  };

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let _transferForm = { ...transferForm, [name]: value };
    if (name === 'fromLocationId') {
      if (value !== '') {
        let locationData = loadLocationData(value);
        _transferForm = {
          ..._transferForm,
          fromLocationAddress: locationData?.address,
          fromLocationType: locationData?.type,
          fromCompanyId: locationData?.companyId,
          assetsInfo: [],
        };
        setInputFields([{ assetCategoryId: '', asset_name: '', asset_number: '', asset_type: '', locationId: '', quantity: '', unit: '' }]);
      } else {
        _transferForm = {
          ..._transferForm,
          fromLocationAddress: '',
          fromLocationType: '',
          fromCompanyId: '',
          assetsInfo: [],
        };
        setInputFields([{ assetCategoryId: '', asset_name: '', asset_number: '', asset_type: '', locationId: '', quantity: '', unit: '' }]);
      }
    } else if (name === 'toLocationId') {
      if (value !== '') {
        let locationData = loadLocationData(value);
        _transferForm = {
          ..._transferForm,
          toLocationAddress: locationData?.address,
          toLocationType: locationData?.type,
          toCompanyId: locationData?.companyId,
        };
      } else {
        _transferForm = {
          ..._transferForm,
          toLocationAddress: '',
          toLocationType: '',
          toCompanyId: '',
        };
      }
    }
    setTransferForm(_transferForm);
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getTransfers();
      }
    },
    [state],
    DEBOUNCE_DELAY
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      post(transferForm, '/transfers/')
        .then((res) => {
          toast.success(res.data.message);
          setShowConfirmModel(false);
          setInputFields([]);
          setTransferForm(formFields);
          getTransfers();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.data?.message || err.message);
        });
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 2000 });
    }
  };

  function getTransfers(conditionType) {
    try {
      if (conditionType === 'excelDownload') {
        get(
          `/transfers/?conditionType=${conditionType}&sourceLocationId=${state.sourceLocationId}&destinationLocationId=${state.destinationLocationId}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}&assetCategoryId=${state.assetCategoryQuery}&companyId=${state.companyId}`
        ).then((response) => {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        });
      } else {
        get(
          `/transfers/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&sourceLocationId=${state.sourceLocationId}&destinationLocationId=${state.destinationLocationId}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}&assetCategoryId=${state.assetCategoryQuery}&companyId=${state.companyId}`
        ).then((response) => {
          setTransferList(response.data.rows);
          setTotalRecords(response.data.count);
        });
      }
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getLocations() {
    try {
      get(`/branches`).then((response) => {
        setLocationList(response.data.rows);
        if (!admins) {
          const data = response?.data?.rows?.find((item) => {
            return item.id === storedData?.locationId[0];
          });
          setSrcLocationType(data?.type);
        }
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getAssetCategories() {
    try {
      get(`/asset-categories`).then((response) => {
        setAssetCategoryList(response.data.rows);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  useEffect(() => {
    getLocations();
    getAssetCategories();
  }, []);

  useEffect(() => {
    getTransfers();
  }, [currentPage]);

  const loadAssetDropdown = async (locationId, assetCatId, index) => {
    if (locationId !== undefined && assetCatId !== undefined) {
      get(`/assets/?locationId=${locationId}&assetCategoryId=${assetCatId}`).then((res) => {
        setAssetList({ ...assetList, [index]: res?.data?.rows });
      });
    }
  };

  const loadAssetData = (assetId, index) => {
    if (assetId !== '') {
      return assetList[index].find((item) => {
        return item?.id === parseInt(assetId);
      });
    }
  };

  const handleAddInput = () => {
    const newAssetInfo = [...inputFields];
    newAssetInfo.push({ assetCategoryId: '', asset_name: '', asset_number: '', asset_type: '', locationId: '', quantity: '', unit: '', vehicleNumber: '', });
    setInputFields(newAssetInfo);
    setTransferForm({ ...transferForm, assetsInfo: newAssetInfo });
  };

  const handleRemoveInput = (index) => {
    const newAssetInfo = [...inputFields];
    newAssetInfo.splice(index, 1);
    setInputFields(newAssetInfo);
    setTransferForm({ ...transferForm, assetsInfo: newAssetInfo });
  };

  const handleInputChange = (index, event, fieldName) => {
    let newAssetInfo = [...inputFields];
    newAssetInfo[index][fieldName] = event.target.value;
    if (fieldName === 'assetCategoryId') {
      let assetCatId = newAssetInfo[index]?.assetCategoryId;
      loadAssetDropdown(transferForm?.fromLocationId, assetCatId, index);
      newAssetInfo[index]['inStockQty'] = '';
      newAssetInfo[index]['unit'] = '';
      newAssetInfo[index]['asset_id'] = '';
      newAssetInfo[index]['asset_type'] = '';
      newAssetInfo[index]['vehicleNumber'] = '';
    } else if (fieldName === 'asset_id') {
      if (event.target.value === '') {
        newAssetInfo[index]['asset_type'] = '';
        newAssetInfo[index]['asset_name'] = '';
        newAssetInfo[index]['asset_number'] = '';
        newAssetInfo[index]['inStockQty'] = '';
        newAssetInfo[index]['unit'] = '';
        newAssetInfo[index]['quantity'] = '';
        newAssetInfo[index]['vehicleNumber'] = '';
      } else {
        let data = loadAssetData(event.target.value, index);
        if (data !== undefined) {
          newAssetInfo[index]['asset_type'] = data.asset_type;
          newAssetInfo[index]['asset_name'] = data.asset_name;
          newAssetInfo[index]['asset_number'] = data.asset_number;
          newAssetInfo[index]['inStockQty'] = data.quantity;
          newAssetInfo[index]['unit'] = data.unit;
          newAssetInfo[index]['quantity'] = '';
          newAssetInfo[index]['vehicleNumber'] = data.vehicleNumber;
        }
      }
    }
    setInputFields(newAssetInfo);
    setTransferForm({ ...transferForm, assetsInfo: newAssetInfo });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Fixed Asset' },
          { link: '#', title: 'Assets Transfer' },
        ]}
      />
      <div className="row justify-content-between align-items-center mt-2">
        <div className="col-12 text-end mb-2">
          <button type="button" className="btn app-btn-default dark-color btn-sm" onClick={handleShow}>
            Add Transfer
          </button>
          <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
            HiddenClick
          </a>
        </div>
      </div>
      <div className="card custom_card">
        <div className="d-flex justify-content-between align-items-center w-100 card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-12 col-lg-1">
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              Transfer | {totalRecords ?? 0}
            </h4>
          </div>
          <div className="col-12 col-lg-2" style={{ margin: '11px' }}>
            <Company
              disabled={!admins}
              company={state.companyId}
              name="company"
              label="Company"
              onChange={(e) => {
                setState({ ...state, companyId: e.target.value, sourceLocationId: '', destinationLocationId: '' });
                setSrcLocationType('');
                setDstLocationType('');
              }}
            />
          </div>
          <div className="col-12 col-lg-9 text-end">
            <div className="row align-items-center">
              <div className="col-4">
                <Form.Select
                  disabled={!admins}
                  value={srcLocationType}
                  onChange={(e) => {
                    setSrcLocationType(e.target.value);
                    setState({ ...state, sourceLocationId: '' });
                  }}
                  className="input mb-2"
                >
                  <option value="">Select Source Type</option>
                  <option value="office">Office</option>
                  <option value="factory">Factory</option>
                  <option value="outlet">Outlet</option>
                  <option value="staff-room">Staff Room</option>
                </Form.Select>
                <Form.Select
                  onChange={(e) => setState({ ...state, sourceLocationId: e.target.value })}
                  className="input"
                  value={state.sourceLocationId}
                >
                  <option value="">Select Source Location</option>
                  {locationList
                    .filter((item) => {
                      if (!admins) {
                        return (
                          storedData?.locationId.includes(item?.id) &&
                          item?.type === srcLocationType &&
                          item.companyId === parseInt(state?.companyId) &&
                          item.id !== parseInt(state.destinationLocationId)
                        );
                      } else {
                        return (
                          item?.type === srcLocationType &&
                          item.companyId === parseInt(state?.companyId) &&
                          item.id !== parseInt(state.destinationLocationId)
                        );
                      }
                    })
                    .map((item) => {
                      return (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                </Form.Select>
              </div>
              <div className="col-3">
                <Form.Select
                  value={dstLocationType}
                  onChange={(e) => {
                    setDstLocationType(e.target.value);
                    setState({ ...state, destinationLocationId: '' });
                  }}
                  className="input mb-2"
                >
                  <option value="">Select Destination Type</option>
                  <option value="office">Office</option>
                  <option value="factory">Factory</option>
                  <option value="outlet">Outlet</option>
                  <option value="staff-room">Staff Room</option>
                </Form.Select>
                <Form.Select
                  onChange={(e) => setState({ ...state, destinationLocationId: e.target.value })}
                  className="input"
                  value={state.destinationLocationId}
                  placeholder="Destination Location"
                >
                  <option value="">Select Destination Location</option>
                  {locationList
                    .filter(
                      (item) =>
                        item?.type === dstLocationType &&
                        item.companyId === parseInt(state?.companyId) &&
                        item.id !== parseInt(state.sourceLocationId)
                    )
                    .map((item) => {
                      return (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                </Form.Select>
              </div>
              <div className="col-4">
                <Form.Select
                  onChange={(e) => setState({ ...state, assetCategoryQuery: e.target.value })}
                  className="input mb-2"
                  value={state.assetCategoryQuery}
                >
                  <option value="">Select Asset Category</option>
                  {assetCategoryList.map((item) => {
                    return (
                      <option key={item?.id} value={item?.id}>
                        {item?.name}
                      </option>
                    );
                  })}
                </Form.Select>
                <div className="d-flex">
                  <div className="col-6 pe-3">
                    <FloatingLabel controlId="floatingInput" label="Transfer Start Date">
                      <Form.Control
                        onChange={(e) => setState({ ...state, dateFrom: e.target.value })}
                        className="input"
                        value={state.dateFrom}
                        type="date"
                      />
                    </FloatingLabel>
                  </div>
                  <div className="col-6">
                    <FloatingLabel controlId="floatingInput" label="Transfer End Date">
                      <Form.Control
                        onChange={(e) => setState({ ...state, dateTo: e.target.value })}
                        className="input"
                        value={state.dateTo}
                        type="date"
                      />
                    </FloatingLabel>
                  </div>
                </div>
              </div>
              <div className="col-1">
                <GrDocumentExcel
                  title="Download transfer report"
                  className="react-icons green"
                  style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                  onClick={() => getTransfers('excelDownload')}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr className="text-center">
                    <th>S.No</th>
                    <th>Date of Transfer</th>
                    <th>Source Location</th>
                    <th>Destination Location</th>
                    <th>Asset Category</th>
                    <th>Asset Name</th>
                    <th>Asset Number</th>
                    <th>Quantity</th>
                    <th>UoM</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {transferList.map((item, index) => {
                    return (
                      <React.Fragment key={item?.id}>
                        <tr className="text-center">
                          <td style={{ verticalAlign: 'middle' }} rowSpan={item?.TransfersDetails.length}>
                            {(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}
                          </td>
                          <td style={{ verticalAlign: 'middle' }} rowSpan={item?.TransfersDetails.length}>
                            {new Date(item?.transferDate).toLocaleDateString('en-GB')}
                          </td>
                          <td style={{ verticalAlign: 'middle' }} rowSpan={item?.TransfersDetails.length}>
                            {item?.fromLocation?.name}
                          </td>
                          <td style={{ verticalAlign: 'middle' }} rowSpan={item?.TransfersDetails.length}>
                            {item?.toLocation?.name}
                          </td>
                          <td>{item?.TransfersDetails[0]?.AssetCategory?.name}</td>
                          <td>{item?.TransfersDetails[0]?.asset_name}</td>
                          <td>{item?.TransfersDetails[0]?.asset_number}</td>
                          <td>{item?.TransfersDetails[0]?.quantity}</td>
                          <td style={{ textTransform: 'capitalize' }}>{item?.TransfersDetails[0]?.unit}</td>
                          <td style={{ verticalAlign: 'middle' }} rowSpan={item?.TransfersDetails.length} className="actions">
                            <Link onClick={(e) => handleViewAndEdit(e, item?.id)}>
                              <ViewIcon style={{ color: 'purple' }} />
                            </Link>
                            <a onClick={(e) => handleViewAndEdit(e, item?.id, 'download')}>
                              <GrDocumentPdf className="react-icons red" title="download pdf" />
                            </a>
                          </td>
                        </tr>
                        {item?.TransfersDetails?.length > 1 &&
                          item?.TransfersDetails.slice(1).map((asset, index) => {
                            return (
                              <tr className="text-center" key={index}>
                                <td className="px-2">{asset?.AssetCategory?.name}</td>
                                <td className="px-2">{asset?.asset_name}</td>
                                <td className="px-2">{asset?.asset_number}</td>
                                <td className="px-2">{asset?.quantity}</td>
                                <td className="px-2" style={{ textTransform: 'capitalize' }}>
                                  {asset?.unit}
                                </td>
                              </tr>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{'id' in transferForm ? 'Transfer Details' : 'Add Transfer Details'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" onSubmit={handleSubmit}>
            <h6>Basic Info</h6>
            <Row>
              <Col xs={12}>
                <FloatingLabel controlId="floatingInput" label="Date of Transfer" className="mb-3">
                  <Form.Control
                    disabled={'id' in transferForm}
                    className="input"
                    name="transferDate"
                    value={transferForm?.transferDate}
                    onChange={(e) => handleChange(e)}
                    type="date"
                    placeholder="Date of Transfer"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <FloatingLabel controlId="floatingInput" label="Source Location" className="mb-3">
                  <Form.Select
                    disabled={'id' in transferForm}
                    className="input"
                    value={transferForm?.fromLocationId}
                    name="fromLocationId"
                    onChange={(e) => handleChange(e)}
                    placeholder="Source Location"
                    required
                  >
                    <option value="">Select Location</option>
                    {locationList
                      .filter((item) => {
                        if (!admins) {
                          return storedData?.locationId.includes(item?.id) && item.id !== parseInt(transferForm?.toLocationId);
                        } else {
                          return item.id !== parseInt(transferForm?.toLocationId);
                        }
                      })
                      .map((item) => {
                        return (
                          <option key={item?.id} value={item?.id}>
                            {item?.name}
                          </option>
                        );
                      })}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={3}>
                <FloatingLabel controlId="floatingInput" label="Source Location Type" className="mb-3">
                  <Form.Select
                    className="input"
                    disabled
                    value={transferForm?.fromLocationType}
                    name="fromLocationType"
                    placeholder="Source Location Type"
                  >
                    <option value="">Location Type</option>
                    <option value="office">Office</option>
                    <option value="factory">Factory</option>
                    <option value="outlet">Outlet</option>
                    <option value="staff-room">Staff Room</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={3}>
                <FloatingLabel controlId="floatingInput" label="Source Location Address" className="mb-3">
                  <Form.Control
                    disabled
                    className="input"
                    name="fromLocationAddress"
                    value={transferForm?.fromLocationAddress}
                    type="text"
                    placeholder="Source Location Address"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={3}>
                <FloatingLabel controlId="floatingInput" label="Company" className="mb-3">
                  <Company
                    disabled
                    name="fromCompanyId"
                    label="Company"
                    company={transferForm.fromCompanyId}
                    onChange={(e) => console.log(e.target.value)}
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <FloatingLabel controlId="floatingInput" label="Destination Location" className="mb-3">
                  <Form.Select
                    disabled={'id' in transferForm}
                    className="input"
                    value={transferForm?.toLocationId}
                    name="toLocationId"
                    onChange={(e) => handleChange(e)}
                    placeholder="Destination Location"
                    required
                  >
                    <option value="">Select Location</option>
                    {locationList
                      .filter((item) => item.id !== parseInt(transferForm?.fromLocationId) && item.isActive === true)
                      .map((item) => {
                        return (
                          <option key={item?.id} value={item?.id}>
                            {item?.name}
                          </option>
                        );
                      })}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={3}>
                <FloatingLabel controlId="floatingInput" label="Destination Location Type" className="mb-3">
                  <Form.Select
                    className="input"
                    disabled
                    value={transferForm?.toLocationType}
                    name="toLocationType"
                    placeholder="Destination Location Type"
                  >
                    <option value="">Location Type</option>
                    <option value="office">Office</option>
                    <option value="factory">Factory</option>
                    <option value="outlet">Outlet</option>
                    <option value="staff-room">Staff Room</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={3}>
                <FloatingLabel controlId="floatingInput" label="Destination Address" className="mb-3">
                  <Form.Control
                    disabled
                    className="input"
                    name="toLocationAddress"
                    value={transferForm?.toLocationAddress}
                    type="text"
                    placeholder="Destination Address"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={3}>
                <FloatingLabel controlId="floatingInput" label="Company" className="mb-3">
                  <Company
                    disabled
                    label="Company"
                    name="toCompanyId"
                    company={transferForm.toCompanyId}
                    onChange={(e) => console.log(e.target.value)}
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-2 align-items-center">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h6 className="mb-0">Asset Info</h6>
              </div>
            </Row>
            {inputFields.map((inputField, index) => (
              <>
                <div key={index} className="asset-info">
                  <Row>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Asset Category" className="mb-3">
                        <Form.Select
                          disabled={'id' in transferForm}
                          className="input"
                          value={inputField.assetCategoryId}
                          name="assetCategoryId"
                          onChange={(e) => handleInputChange(index, e, 'assetCategoryId')}
                          required
                        >
                          <option value="">Select Category</option>
                          {assetCategoryList.map((item) => {
                            return (
                              <option key={item?.id} value={item?.id}>
                                {item?.name}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col xs={4} className="mb-3">
                      <FloatingLabel controlId="floatingInput" label="Asset Name" >
                        <Form.Select
                          disabled={'id' in transferForm || inputField.assetCategoryId === ''}
                          className="input"
                          value={inputField.asset_id}
                          name="asset_name"
                          onChange={(e) => handleInputChange(index, e, 'asset_id')}
                          placeholder="Asset Name"
                          required
                        >
                          <option value="">Select Asset Name</option>
                          {assetList[index]?.map((item) => (
                            <option key={item?.id} value={item?.id}>
                              {item?.asset_name} ({item?.asset_number}) {item?.vehicleNumber ? `[${item?.vehicleNumber}]` : ''}
                            </option>
                          ))}
                        </Form.Select>
                      </FloatingLabel>
                      {inputField.vehicleNumber && (
                        <div style={{ fontSize: '0.9em', color: 'red' }}>
                          Vehicle Number: {inputField.vehicleNumber}
                        </div>
                      )}
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Asset Type" className="mb-3">
                        <Form.Select
                          disabled
                          className="input"
                          value={inputField.asset_type}
                          name="asset_type"
                          onChange={(e) => handleInputChange(index, e, 'asset_type')}
                          placeholder="Asset Type"
                        >
                          <option value="">Select Type</option>
                          <option value="tan">TAN</option>
                          <option value="int">INT</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Quantity">
                        <Form.Control
                          disabled={'id' in transferForm || inputField?.inStockQty <= 0}
                          className="input"
                          name="quantity"
                          value={inputField.quantity}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (!isNaN(value) && value >= 0) {
                              handleInputChange(index, e, 'quantity');
                            }
                          }}
                          type="text"
                          placeholder="Quantity"
                          required
                        />
                      </FloatingLabel>
                      <span
                        className={inputField?.inStockQty >= 0 && inputField?.inStockQty !== '' ? 'text-danger' : 'd-none'}
                        style={{ fontSize: '13px', position: 'absolute' }}
                      >
                        Avl Qty {inputField?.inStockQty}
                      </span>
                    </Col>
                    <Col xs={3}>
                      <FloatingLabel controlId="floatingInput" label="Unit" className="mb-3">
                        <Form.Select
                          disabled
                          className="input"
                          value={inputField.unit}
                          name="unit"
                          onChange={(e) => handleInputChange(index, e, 'unit')}
                        >
                          <option value="">Select Unit</option>
                          <option value="number">Number</option>
                          <option value="set">Set</option>
                          <option value="pc">Pc</option>
                          <option value="kg">Kg</option>
                          <option value="meter">Meter</option>
                          <option value="roll">Roll</option>
                          <option value="ls">LS</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col xs={4} className="mb-3">
                      <FloatingLabel controlId="floatingInput" label="Asset Number">
                        <Form.Control
                          disabled
                          className="input"
                          name="asset_number"
                          value={inputField.asset_number}
                          onChange={(e) => handleInputChange(index, e, 'asset_number')}
                          type="text"
                          placeholder="Asset Number"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={1} className={'id' in transferForm ? 'd-none' : 'text-end mt-3'}>
                      {inputFields.length > 1 && (
                        <MdDelete
                          onClick={() => handleRemoveInput(index)}
                          className="text-danger"
                          style={{ cursor: 'pointer', fontSize: '27px' }}
                        />
                      )}
                    </Col>
                  </Row>
                </div>
                <hr />
              </>
            ))}
            {'id' in transferForm ? (
              ''
            ) : (
              <Button type="button" ref={clickAssetBtn} variant="secondary" size="sm" onClick={handleAddInput}>
                Add Asset Info
              </Button>
            )}
            <Col>
              <Button type="submit" className={'id' in transferForm ? 'd-none' : 'add-request-btn mt-4 mb-3 justify-content-center'}>
                Add
              </Button>
            </Col>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default Transfer;
